import axios from "axios";
import { environment } from "../../environment";
import { clean, toFormData } from "../../helpers/helpers";

class UsersService {

    async getUserByConnectId(uid: string) {
        try {
            const path = environment.usersUrl + 'user/' + uid;
            const res: any = await axios.get(path);
            if (res?.data)
                return res.data;
            else throw new Error('No user found')
        } catch (err) {
            throw err;
        }
    }

    async getUserDataByEmail(email: string) {
        try {
            const path = environment.usersUrl + 'user/data/' + email;
            const res: any = await axios.get(path);
            if (res?.data) {
                return res.data;
            } else {
                localStorage.removeItem('token');
                throw new Error('No user or non valid token')
            }
        } catch (err) {
            throw err;
        }
    }

    async getUserById(uid: string) {
        try {
            const path = environment.usersUrl + 'user/hid/' + uid;
            const res: any = await axios.get(path);
            if (res?.data)
                return res.data;
            else throw new Error('No user found')
        } catch (err) {
            throw err;
        }
    }

    async resetUserById(uid: string, email: string) {
        try {

            const resetData = {
                hash: uid,
                email: email,
            };

            const res: any = await axios.post(environment.usersUrl + "user/resetByHash", resetData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (res)
                return res.data;

        } catch (err) {
            throw new Error('No user found', err);
        }
    }

    async me() {
        try {
            const path = environment.usersUrl + 'me';
            const res: any = await axios.get(path);
            if (res?.data) {
                return res.data;
            } else {
                localStorage.removeItem('token');
                throw new Error('No user or non valid token')
            }
        } catch (err) {
            throw err;
        }
    }


    async shareAttachmentToEmail( attachment: any, user: any) {
        try {
            const formData = {
                userId: user._id,
                email: user.email,
                url: attachment
            };

            return await axios.post(environment.usersUrl + "mailer/share-attachment-to-email", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
        } catch (err) {
            throw err;
        }
    }

    async invitation(user: any) {
        try {
            delete user['rePassword']
            const path = environment.usersUrl + 'client/user/invitation';
            const formData = toFormData(user);
            const res: any = await axios.put(path, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
            return res;
        } catch (err) {
            throw err
        }
    }



  async resetpassword(uid: string) {
    try {
      const path = `${environment.authUrl}mailer/resetpassword`;
      const res = await axios.put(path, { uid });
      return res.data;
    } catch (err) {
      throw err;
    }
  };    


    async updatePassword(user: any) {
        try {
            const path = environment.usersUrl + 'client/user/updatepassword';
            const cleanUser = clean(user);
            const formData = toFormData(cleanUser);
            const res: any = await axios.put(path, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
            return res;
        } catch (err) {
            throw err
        }
    }


    async update(user: any) {
        try {
            const path = environment.usersUrl + 'client/user/update';
            const cleanUser = clean(user);
            const formData = toFormData(cleanUser);
            const res: any = await axios.put(path, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
            return res;
        } catch (err) {
            throw err
        }
    }


    async updateUserProfile(user: any) {
        try {
            const path = environment.contentUrl + 'user/update';
            const cleanUser = clean(user);
            const formData = toFormData(cleanUser);
            const res: any = await axios.put(path, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
            return res;
        } catch (err) {
            throw err
        }
    }

    async getUsersByCourseId(courseId: string) {
        try {
            const path = environment.authUrl + 'client/users/courseId/' + courseId;
            const res: any = await axios.get(path);
            return res.data;
        } catch (err) {
            throw err;
        }
    }

    async getFriendsByUserId(uid: string) {
        try {
            if (!navigator.userAgent.match(/Android/i) && !navigator.userAgent.match(/iPhone/i)){
                const path = environment.usersUrl + 'client/users/friends/' + uid;
                const res: any = await axios.get(path);
                return res.data;
            } else {
                return [];
            }

        } catch (err) {
            throw err;
        }
    }

    async getParticipantsByEventId(eventid: string) {
        try {
            const path = environment.usersUrl + 'client/users/event/participants/' + eventid;
            const res: any = await axios.get(path);
            return res.data;
        } catch (err) {
            throw err;
        }
    }


    async getHRusers() {
        try {
            if (!navigator.userAgent.match(/Android/i) && !navigator.userAgent.match(/iPhone/i)){
                const path = environment.usersUrl + 'client/users/shihr/members/';
                const res: any = await axios.get(path);
                return res.data;
            } else {
                return [];
            }

        } catch (err) {
            throw err;
        }
    }

    async getCurriculaByUserId(userId: string) {
        try {
            const path = environment.authUrl +  userId +  '/curriculaData' ;
            const res: any = await axios.get(path);
            return res.data;
        } catch (err) {
            throw err;
        }
    }

}

export default new UsersService() as UsersService;